import React, { useState } from "react";
import { Stack, Input, FormLabel, Select } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";
import CategorySelect from "./CategoryList";


const AddHelpTopicDrawer = ({ isOpen, onClose, onAddHelpTopic }) => {
  const [formData, setFormData] = useState({
    title: "",
    category: "",
    description: "",
    image: null,
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFormData(prev => ({
        ...prev,
        image: e.target.files[0],
      }));
    }
  };

  const handleSubmit = async () => {
    // Validate required fields
    if (!formData.title || !formData.category || !formData.description) {
      alert("Please fill all required fields");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('title', formData.title);
    formDataToSend.append('category', formData.category);
    formDataToSend.append('description', formData.description);
    
    // Only append image if it exists
    if (formData.image) {
      formDataToSend.append('image', formData.image);
    }

    try {
      await onAddHelpTopic(formDataToSend);
      
      // Reset form on success
      setFormData({
        title: "",
        category: "",
        description: "",
        image: null,
      });
      onClose();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Add New Help Topic</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Title"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            placeholder="Enter topic title"
            isRequired
          />
       
      <CategorySelect
        value={formData.category}
        onChange={handleInputChange}
        isRequired
      />

          <ReusableInput
            label="Description"
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            placeholder="Enter message or description"
            type="textarea"
            isRequired
          />

          <FormLabel color="gray.400">Image</FormLabel>
          <Input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleFileChange}
            variant="unstyled"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton 
            fontSize="15px" 
            width="100px" 
            height="40px" 
            onClick={onClose}
          >
            Cancel
          </GradientButton>
          <GradientButton 
            fontSize="15px" 
            width="80px" 
            height="40px" 
            onClick={handleSubmit}
          >
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AddHelpTopicDrawer;